var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"side_icon_menu_wrap"},[_c('div',{staticClass:"side_icon_menu",on:{"click":function($event){$event.stopPropagation();$event.preventDefault();}}},[_c('div',{staticClass:"side_icon_arrow pr-2"},[_c('v-icon',{attrs:{"color":"white"}},[_vm._v("mdi-chevron-left")])],1),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }